import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const TrainingCatalogPage = lazy(() => import('../pages/training-catalog/page'));
const CreateCampaignPage = lazy(() => import('../pages/create-campaign/page'));
const AdTemplatesPage = lazy(() => import('../pages/ad-templates/page'));
const LeadsCRMPage = lazy(() => import('../pages/leads-crm/page'));
const CertificatesPage = lazy(() => import('../pages/certificates/page'));
const AnalyticsPage = lazy(() => import('../pages/analytics/page'));
const SettingsPage = lazy(() => import('../pages/settings/page'));
const FranchiseApplyPage = lazy(() => import('../pages/franchise-apply/page'));
const FranchiseApplyFormPage = lazy(() => import('../pages/franchise-apply/form/page'));
const FranchiseApplicationsPage = lazy(() => import('../pages/franchise-applications/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Navigate to="/dashboard" replace />
  },
  {
    path: '/login',
    element: <LoginPage />
  },
  {
    path: '/franchise-apply',
    element: <FranchiseApplyPage />
  },
  {
    path: '/franchise-apply/form',
    element: <FranchiseApplyFormPage />
  },
  {
    path: '/dashboard',
    element: <DashboardPage />
  },
  {
    path: '/training-catalog',
    element: <TrainingCatalogPage />
  },
  {
    path: '/create-campaign',
    element: <CreateCampaignPage />
  },
  {
    path: '/ad-templates',
    element: <AdTemplatesPage />
  },
  {
    path: '/leads-crm',
    element: <LeadsCRMPage />
  },
  {
    path: '/certificates',
    element: <CertificatesPage />
  },
  {
    path: '/analytics',
    element: <AnalyticsPage />
  },
  {
    path: '/settings',
    element: <SettingsPage />
  },
  {
    path: '/franchise-applications',
    element: <FranchiseApplicationsPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
